import apiFetch from '../../apiFetch'

export default function (token, organizedUnitId) {
  return apiFetch({ endPoint: 'RatingByOrganizedUnit?organizedUnitId=' + organizedUnitId, method: 'GET', token: token })
}
